<template>
  <div class="money">
    <div class="money-content">
      <div class="money-content-head">
        <div>我要捐款</div>
        <div><img src="@/assets/line.png" alt="" /></div>
        <div>I WANT TO DONATE</div>
      </div>
      <div class="money-main">
        <div class="money-card">
          <div>捐款方式：</div>
          <div>请按以下户名、银行、帐号的信息进行转账。</div>
          <div>
            户名：<input type="text" v-model="name" disabled class="name" />
          </div>
          <div>
            银行：<input type="text" v-model="bank" disabled class="bank" />
          </div>
          <div>
            账号：<input type="text" v-model="account" class="account" disabled/>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      account: "4559 6472 3214",
      bank: "中国银行股份有限公司上海市浦东支行",
      name: "上海东方希望公益基金会",
      disabled:true
    };
  },
};
</script>
<style lang="scss" scoped>
.account {
  border: none;
  background: #f9fafc;
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}
.name,
.bank {
  border: none;
  background: #f9fafc;
  width: 315px;
}
.money {
  width: 100%;
}
.money-content {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 60px 0;
  .money-content-head {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div:nth-child(1) {
      font-size: 26px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      color: #333333;
    }
    > div:nth-child(2) {
      margin-top: 12px;
    }
    > div:nth-child(3) {
      font-size: 12px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #999999;
      margin-top: 14px;
    }
  }
}
.money-main {
  width: 1100px;
  height: 344px;
  background: url("../../assets/juankuanbg.png");
  padding: 37px 221px 24px 221px;
  margin: 0 auto;
  .money-card {
    width: 658px;
    height: 283px;
    background: url("../../assets/juankuankapian.png");
    padding-top: 40px;
    padding-left: 58px;
    > div:nth-child(1) {
      font-size: 16px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #333333;
    }
    > div:nth-child(2) {
      font-size: 14px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #777777;
      margin-top: 8px;
    }
    > div:nth-child(3) {
      font-size: 14px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #333333;
      margin-top: 17px;
    }
    > div:nth-child(4) {
      font-size: 14px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
    }
    > div:nth-child(5) {
      font-size: 14px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
    }
  }
}
</style>